module.exports = __webpack_public_path__ + "img/LB1.e38e5981.jpg";